const Day = day => {
  const date = day.getDate();
  return /*#__PURE__*/React.createElement("span", null, date);
};
export default Day;